module.exports = __webpack_public_path__ + "img/vn.faa818be.svg";